module.exports = __webpack_public_path__ + "img/logo-training.6bf91e09.svg";